/**
 * Availability Slots API endpoints
 */
import { api } from './baseApi';

export interface AvailabilitySlot {
  id: number;
  specialist: number | null;
  specialist_name: string | null;
  specialist_email: string | null;
  consultant: number | null;
  consultant_name: string | null;
  consultant_email: string | null;
  provider_type: 'SPECIALIST' | 'CONSULTANT';
  date: string;
  day_name: string;
  is_past: boolean;
  start_time: string;
  end_time: string;
  slot_duration: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

interface PaginatedResponse<T> {
  success: boolean;
  count: number;
  next: string | null;
  previous: string | null;
  total_pages: number;
  current_page: number;
  results: T[];
}

interface AvailabilitySlotResponse {
  success: boolean;
  message: string;
  data: AvailabilitySlot | AvailabilitySlot[];
}

interface AvailabilitySlotsParams {
  specialist_id?: number;
  consultant_id?: number;
  is_active?: boolean;
  page?: number;
  page_size?: number;
}

interface CreateAvailabilitySlotRequest {
  specialist?: number;
  consultant?: number;
  days: string[];
  start_time: string;
  end_time: string;
}

export const availabilitySlotsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAvailabilitySlots: builder.query<PaginatedResponse<AvailabilitySlot>, AvailabilitySlotsParams>({
      query: (params) => ({
        url: '/dashboard/availability-slots/',
        params,
      }),
      providesTags: ['Specialists', 'Consultants'],
    }),
    createAvailabilitySlot: builder.mutation<AvailabilitySlotResponse, CreateAvailabilitySlotRequest>({
      query: (body) => ({
        url: '/dashboard/availability-slots/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Specialists', 'Consultants'],
    }),
    updateAvailabilitySlot: builder.mutation<AvailabilitySlotResponse, { id: number; data: Partial<CreateAvailabilitySlotRequest> }>({
      query: ({ id, data }) => ({
        url: `/dashboard/availability-slots/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Specialists', 'Consultants'],
    }),
    deleteAvailabilitySlot: builder.mutation<void, number>({
      query: (id) => ({
        url: `/dashboard/availability-slots/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Specialists', 'Consultants'],
    }),
  }),
});

export const {
  useGetAvailabilitySlotsQuery,
  useCreateAvailabilitySlotMutation,
  useUpdateAvailabilitySlotMutation,
  useDeleteAvailabilitySlotMutation,
} = availabilitySlotsApi;

